export default {
  SET_REGIST_INFO(state, registInfo) {
    state.registInfo = registInfo;
  },
  SET_CARD_INFO(state, cardInfo) {
    state.cardInfo = cardInfo;
  },
  RESET_REGIST_INFO(state) {
    state.registInfo = {};
  },
  SET_FORM_DATA(state, formData) {
    state.formData = formData;
    sessionStorage.setItem('formData', JSON.stringify(formData));
  },
  RESET_FORM_DATA(state) {
    state.formData = {};
    sessionStorage.removeItem('formData');
  },
  SET_CPM_DETAIL(state, list) {
    state.cpmDetail = list;
  },
  RESET_CPM_DETAIL(state) {
    state.cpmDetail = {};
  },
  SET_DELETE_CARD_STATUS(state, data) {
    state.deleteCardStatus = data;
  },
};
